/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "87beea9293e4ed85eb2535095237476199297d55";
